import React, { Component, ReactElement } from 'react';

import styles from 'buyside/components/presentation/CompanyShowPage/CompanyBuysideConsensus/companyChartStyles.scss';

import BuysideConsensusMain from 'buyside/components/presentation/CompanyShowPage/CompanyBuysideConsensus/buysideConsensusMain';
import BuysideConsensusSidebar from 'buyside/components/presentation/CompanyShowPage/CompanyBuysideConsensus/BuysideConsensusSidebar/buysideConsensusSidebar';
import PriceChart from 'buyside/components/presentation/Charts/PriceChart/priceChart';

import { EntityPollQuery, Maybe } from 'interfaces/graphql-typings';
export type CompanyQuestion = NonNullable<EntityPollQuery['companyQuestions']>[number];
export type Entity = NonNullable<EntityPollQuery['entity']>;
type BSCContainerProps = {
  entity: Entity;
  companyQuestions: CompanyQuestion[];
  recordResponse: (id: string, answers: string[], skipped: boolean) => void;
  showPoll: boolean;
  showUserDetails: boolean;
  assetId?: Maybe<string>;
};
class BuysideConsensusContainer extends Component<
  BSCContainerProps,
  {
    activeIdx: number;
    showPriceChart: boolean;
    questionOrder: string[];
  }
> {
  constructor(props: BSCContainerProps) {
    super(props);
    this.state = {
      activeIdx: 0,
      showPriceChart: false,
      questionOrder: props.companyQuestions.map((q): CompanyQuestion['id'] => q.id)
    };
    this.updateActiveIdx = this.updateActiveIdx.bind(this);
    this.toggleMainArea = this.toggleMainArea.bind(this);
    this.handleAnswer = this.handleAnswer.bind(this);
    this.handleSkip = this.handleSkip.bind(this);
  }

  updateActiveIdx(idx: number): void {
    this.setState({ activeIdx: idx === this.props.companyQuestions.length ? 0 : idx });
  }

  toggleMainArea(boolean: boolean): void {
    this.setState({ showPriceChart: boolean });
  }

  sortQuestions(questions: CompanyQuestion[], order: string[]): CompanyQuestion[] {
    return order
      .map((i): CompanyQuestion | undefined => questions.find((q): boolean => q.id === i))
      .filter(Boolean) as CompanyQuestion[];
  }

  handleResponse(id: string, skipped: boolean, answers?: string[]): void {
    this.updateActiveIdx(this.state.questionOrder.indexOf(id) + 1);
    this.props.recordResponse(id, answers || [], skipped);
  }

  handleAnswer(id: string, answers: string[]): void {
    this.handleResponse(id, false, answers);
  }

  handleSkip(id: string): void {
    this.handleResponse(id, true);
  }

  render(): ReactElement {
    const { activeIdx, showPriceChart, questionOrder } = this.state;
    const { companyQuestions, entity, showPoll, assetId, showUserDetails } = this.props;
    const sortedQuestions = this.sortQuestions(companyQuestions, questionOrder);

    return (
      <div className={styles.companyChartWrapper}>
        <div className={styles.chartSidebarWrapper}>
          <BuysideConsensusSidebar
            items={sortedQuestions.map(({ name }): CompanyQuestion['name'] => name)}
            activeIdx={activeIdx}
            showPriceChart={showPriceChart}
            updateActiveIdx={this.updateActiveIdx}
            returnToPoll={(): void => this.toggleMainArea(false)}
          />
        </div>
        {showPriceChart && assetId && (
          <PriceChart
            assetId={assetId}
            currencyCode={entity.currencyCode || null}
            entityName={entity.name || null}
            primarySymbol={entity.primarySymbol || null}
            showUserDetails={showUserDetails}
            toggleMainArea={this.toggleMainArea}
          />
        )}
        {!showPriceChart && showPoll && (
          <BuysideConsensusMain
            companyQuestions={sortedQuestions}
            handleAnswer={this.handleAnswer}
            handleSkip={this.handleSkip}
            activeIdx={activeIdx}
            toggleMainArea={this.toggleMainArea}
          />
        )}
      </div>
    );
  }
}

export default BuysideConsensusContainer;
